module.exports = __webpack_public_path__ + "img/pending.9b4f2b32.png";